import { Component, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { IonButton, IonCol, IonGrid, IonRow } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import {
  getEmptyFreightBasicForShipper,
  getEmptyFreightDetailForShipper,
  IFreightBasicForShipper,
  IFreightDetailedForShipper,
  UUID_NULL,
} from '@okcargo-apps/shared-domain';
import { ConnectivityService } from '@okcargo-apps/shared-infrastructure';
import { FreightShipperFormsTriggersService } from '../freight-shipper-forms-triggers.service';

@Component({
  selector: 'lib-freight-shipper-footer-buttons',
  templateUrl: './freight-shipper-footer-buttons.component.html',
  styleUrls: ['./freight-shipper-footer-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonButton, IonCol, IonRow, IonGrid, TranslateModule],
})
export class FreightShipperFooterButtonsComponent {
  private readonly freightShipFormsTriggersService = inject(FreightShipperFormsTriggersService);
  private readonly connectivity = inject(ConnectivityService);

  /** Publishing or saving a freight is a command: it cannot be done without connection. */
  protected readonly isOffline = this.connectivity.isOffline;

  @Input()
  id!: string;

  public freight: IFreightDetailedForShipper = getEmptyFreightDetailForShipper();
  public freightBasic: IFreightBasicForShipper = getEmptyFreightBasicForShipper();

  public isNew(): boolean {
    return this.id === UUID_NULL;
  }

  public updateOrCreateFreight(): void {
    if (this.isOffline()) return;

    this.freightShipFormsTriggersService.launchFreightShipperSaveTrigger();
  }

  public addStop(): void {
    this.freightShipFormsTriggersService.launchAddStopTrigger();
  }
}
